import { render, staticRenderFns } from "./BlastList.vue?vue&type=template&id=25840e31&"
import script from "./BlastList.vue?vue&type=script&lang=js&"
export * from "./BlastList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports